import { render, staticRenderFns } from "./ChecklistItem.vue?vue&type=template&id=696ffe02&scoped=true"
import script from "./ChecklistItem.vue?vue&type=script&lang=js"
export * from "./ChecklistItem.vue?vue&type=script&lang=js"
import style0 from "./ChecklistItem.vue?vue&type=style&index=0&id=696ffe02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ffe02",
  null
  
)

export default component.exports